<template>
  <span class="font-12 fst-italic text-danger">{{ message }}</span>
</template>

<script>
export default {
  name: 'InputError',
  components: {},
  props: ['message']
}
</script>

<style>

</style>